import { useEffect, useState } from "react"

const UseToken = user =>{
    const [token, setToken] = useState('')
    useEffect(()=>{
        const email = user?.user?.email;
        const currentUser = {email:email}
        if(email){
            fetch(`https://desolate-ridge-76720.herokuapp.com/user/${email}`,{
                method:'PUT',
                headers:{
                    'content-type':'application/json'
                },
                body:JSON.stringify(currentUser)
            })
            .then(res=>res.json())
            .then(data=>{
                const accessToken = data.token;
                localStorage.setItem('accessToken', accessToken)
                setToken(accessToken)
            })
        }

    },[user])
    return [token];
}
export default UseToken;